// Example: src/pages/Login/ResetPassword.tsx
import { useState } from 'react'
import { confirmResetPassword, ConfirmResetPasswordInput, resetPassword } from 'aws-amplify/auth'
import { FieldValues, useForm } from 'react-hook-form'
import AuthLayout from '../../components/AuthLayout/AuthLayout'
import Button from '../../components/Button/Button'
import { Link } from 'react-router-dom'
import DynamicFaIcon from '../../components/DynamicFaIcon/DynamicFaIcon'

export default function ResetPassword() {
    const [step, setStep] = useState<'request' | 'submit'>('request')
    const [message, setMessage] = useState('')
    const [submitted, setSubmitted] = useState(false)
    const [error, setError] = useState('')
    const [email, setEmail] = useState('')
    const [loading, setLoading] = useState(false)

    const { register: registerResetField, handleSubmit: handleSubmitReset } = useForm()
    const { register: registerPasswordField, handleSubmit: handleSubmitPassword } = useForm()

    const requestReset = async ({ email }: FieldValues) => {
        setLoading(true)
        setError('')
        try {
            await resetPassword({ username: email })
            setStep('submit')
            setMessage('Controleer je e-mailbox voor de verificatiecode.')
        } catch (err: any) {
            setError(err.message)
        } finally {
            setLoading(false)
        }
    }

    const submitNewPassword = async ({ verificationCode, newPassword }: FieldValues) => {
        setError('')
        setLoading(true)
        const params: ConfirmResetPasswordInput = {
            username: email,
            confirmationCode: verificationCode,
            newPassword: newPassword
        }
        try {
            // await updatePassword({ code, password })
            await confirmResetPassword(params)
            setMessage('Wachtwoord gereset! U kunt nu inloggen.')
            setSubmitted(true)
        } catch (err: any) {
            setError(err.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <AuthLayout>
            <div className='rounded-xl bg-white border p-10 text-left text-[--tb-text] max-w-[600px] w-full flex flex-col space-y-4 shadow-lg relative z-20'>
                <h3 className='text-3xl text-center'>Wachtwoord opnieuw instellen</h3>
                {message && <div className='text-center pb-2'>{message}</div>}
                {step === 'request' && (
                    <form onSubmit={handleSubmitReset(requestReset)} className='flex flex-col space-y-4 my-4'>
                        <span className='font-semibold'>Vul uw e-mailadres/gebruikersnaam in</span>
                        <input
                            {...registerResetField('email', { required: true })}
                            id='email'
                            type='email'
                            className='border border-gray-200 rounded-md'
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder='E-mailadres'
                            autoComplete='email'
                            required
                        />
                        {/* <button type='submit'>Send reset code</button> */}
                        <Button type='submit' disabled={loading}>
                            {loading ? (
                                <>
                                    <DynamicFaIcon iconName='spinner' className='mr-2' spin />
                                    Verzenden..
                                </>
                            ) : (
                                <span>Verzend resetcode</span>
                            )}
                        </Button>
                    </form>
                )}
                {step === 'submit' && !submitted && (
                    <form onSubmit={handleSubmitPassword(submitNewPassword)} className='flex flex-col space-y-4 my-4'>
                        <span className='font-semibold'>Verificatiecode uit de e-mail</span>
                        <input
                            {...registerPasswordField('verificationCode', { required: true })}
                            id='verificationCode'
                            name='verificationCode'
                            type='text'
                            placeholder='Verificatiecode'
                            autoComplete='one-time-code'
                            inputMode='none'
                            autoCorrect='off'
                            autoCapitalize='off'
                            spellCheck={false}
                            required
                        />
                        <span className='font-semibold'>Uw nieuwe wachtwoord</span>
                        <input
                            {...registerPasswordField('newPassword', { required: true })}
                            id='newPassword'
                            name='newPassword'
                            autoComplete='new-password'
                            type='password'
                            placeholder='Nieuwe wachtwoord'
                            required
                        />
                        <Button type='submit' disabled={loading}>
                            {loading ? (
                                <>
                                    <DynamicFaIcon iconName='spinner' className='mr-2' spin />
                                    Opslaan..
                                </>
                            ) : (
                                <span>Opslaan</span>
                            )}
                        </Button>
                    </form>
                )}
                {error && <div style={{ color: 'red' }}>{error}</div>}
                <Link to='/login' className='text-[--tb-text] mx-auto block text-sm text-center'>
                    Terug naar inloggen
                </Link>
            </div>
        </AuthLayout>
    )
}
